exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hasResults[data-v-1e5f83e4]{display:inline}.noResults[data-v-1e5f83e4]{display:none}.class-wrapper[data-v-1e5f83e4]{width:100%}.showTick[data-v-1e5f83e4]{display:inline;color:green}.hideTick[data-v-1e5f83e4]{display:none}.ungraded[data-v-1e5f83e4]{color:#ec4949}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e5f83e4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GradingTabs.vue
// module id = 593
// module chunks = 0